import { render, staticRenderFns } from "./propertyCreate.vue?vue&type=template&id=f7bd1bf2&scoped=true&"
import script from "./propertyCreate.vue?vue&type=script&lang=js&"
export * from "./propertyCreate.vue?vue&type=script&lang=js&"
import style0 from "./propertyCreate.vue?vue&type=style&index=0&id=f7bd1bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bd1bf2",
  null
  
)

export default component.exports